// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel .container {
  position: relative;
}

.carousel-control {
  background: rgba(0, 0, 0, 0.55) !important;
  height: 60px;
  width: 40px;
  top: 50%;
  margin-top: -30px;
}

.carousel-control i,
.carousel-control .glyphicon {
  display: block;
  margin: 0;
  text-align: center;
  line-height: 60px;
  position: initial;
  height: 60px;
  font-size: 32px;
}

.carousel-caption-right {
  text-align: right;
}

.carousel-caption-left {
  text-align: left;
}

.carousel-caption {
  text-shadow: none;
  right: 0;
  left: 0;
  top: 60px;
  bottom: 60px;
  font-weight: 300;
}

.carousel-caption .container {
  padding: 0 60px;
}

.carousel-caption .title {
  font-size: 64px;
  margin: 0;
  font-weight: 600;
}

.carousel-caption .price {
  font-size: 36px;
  margin: 0;
  font-weight: 600;
}

.carousel-caption .price small {
  font-size: 24px;
}

.carousel-caption .price span {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding-left: 10px;
  padding-right: 10px;
}

.carousel-caption .btn {
  border: 2px solid #fff;
  color: #fff;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 30px;
  border-radius: 6px;
}

.carousel-caption .btn:hover,
.carousel-caption .btn:focus {
  background: rgba(255, 255, 255, 0.25);
}

.carousel-caption p {
  margin-bottom: 0;
  font-size: 26px;
}

.carousel-caption.text-inverse .btn {
  border-color: #333;
  color: #333;
  font-weight: 600;
}

.carousel .product-img {
  position: absolute;
  top: 40px;
  max-height: 370px;
}

.carousel .product-img.left {
  left: 60px;
}

.carousel .product-img.right {
  right: 60px;
}

.carousel .product-img.bottom {
  bottom: 0;
}

.carousel .bg-cover-img {
  max-width: 100%;
  position: absolute;
  min-height: 100%;
}

.slider .carousel,
.carousel .carousel-inner,
.carousel .carousel-inner .item {
  min-height: 450px;
}

.carousel-indicators li {
  border-width: 2px;
}

/* 9.2 Item Element Setting */
.item {
  background: #fff;
}

.item.item-thumbnail {
  border-radius: 3px;
  border: 1px solid #c5ced4;
}

.item.item-thumbnail a,
.item.item-thumbnail a:hover,
.item.item-thumbnail a:focus {
  text-decoration: none;
}

.item.item-thumbnail .item-image {
  height: 130px;
  text-align: center;
  padding: 15px;
  line-height: 100px;
  display: block;
  position: relative;
}

.item.item-thumbnail .item-image .discount {
  position: absolute;
  bottom: 0;
  right: 15px;
  line-height: 20px;
  padding: 2px 10px;
  color: #fff;
  background: #2d353c;
  font-weight: 600;
  font-size: 13px;
}

.item.item-thumbnail .item-image img {
  max-width: 100%;
  max-height: 100%;
}

.item.item-thumbnail .item-info {
  padding: 15px;
  text-align: center;
}

.item.item-thumbnail .item-title {
  margin: 0 0 3px;
}

.item.item-thumbnail .item-title,
.item.item-thumbnail .item-title a {
  font-weight: 600;
  color: #212121;
  font-size: 14px;
  line-height: 18px;
  max-height: 36px;
  overflow: hidden;
}

.item.item-thumbnail .item-title a:hover,
.item.item-thumbnail .item-title a:focus {
  color: #009688;
}

.item.item-thumbnail .item-desc {
  margin: 0;
  font-size: 12px;
  color: #707478;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item.item-thumbnail .item-discount-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}

.item.item-thumbnail .item-price {
  margin: 3px 0;
  font-size: 16px;
  color: #009688;
  font-weight: 600;
}

.caurosel-bg-cover-img {
  position: relative !important;
  width: 100%;
}

.caurosel-image-container {
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/main/marketing/marketing-slider/marketing-slider.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AACA;EACI,0CAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;AAEJ;;AAAA;;EAEI,cAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAGJ;;AADA;EACI,iBAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,iBAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,eAAA;AAOJ;;AALA;EACI,eAAA;EACA,SAAA;EACA,gBAAA;AAQJ;;AANA;EACI,eAAA;EACA,SAAA;EACA,gBAAA;AASJ;;AAPA;EACI,eAAA;AAUJ;;AARA;EACI,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAWJ;;AATA;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAYJ;;AAVA;;EAEI,qCAAA;AAaJ;;AAXA;EACI,gBAAA;EACA,eAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;AAeJ;;AAbA;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;AAgBJ;;AAdA;EACI,UAAA;AAiBJ;;AAfA;EACI,WAAA;AAkBJ;;AAhBA;EACI,SAAA;AAmBJ;;AAjBA;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AAoBJ;;AAlBA;;;EAGI,iBAAA;AAqBJ;;AAnBA;EACI,iBAAA;AAsBJ;;AAlBA,6BAAA;AAEA;EACI,gBAAA;AAoBJ;;AAlBA;EAGI,kBAAA;EACA,yBAAA;AAqBJ;;AAnBA;;;EAGI,qBAAA;AAsBJ;;AApBA;EACI,aAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAuBJ;;AArBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAwBJ;;AAtBA;EACI,eAAA;EACA,gBAAA;AAyBJ;;AAvBA;EACI,aAAA;EACA,kBAAA;AA0BJ;;AAxBA;EACI,eAAA;AA2BJ;;AAzBA;;EAEI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AA4BJ;;AA1BA;;EAEI,cAAA;AA6BJ;;AA3BA;EACI,SAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA8BJ;;AA5BA;EACI,eAAA;EACA,WAAA;EACA,6BAAA;AA+BJ;;AA7BA;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAgCJ;;AA7BA;EACI,6BAAA;EACA,WAAA;AAgCJ;;AA7BA;EACI,6BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAgCJ","sourcesContent":[".carousel .container {\n    position: relative;\n}\n.carousel-control {\n    background: rgba(0,0,0,0.55) !important;\n    height: 60px;\n    width: 40px;\n    top: 50%;\n    margin-top: -30px;\n}\n.carousel-control i,\n.carousel-control .glyphicon {\n    display: block;\n    margin: 0;\n    text-align: center;\n    line-height: 60px;\n    position: initial;\n    height: 60px;\n    font-size: 32px;\n}\n.carousel-caption-right {\n    text-align: right;\n}\n.carousel-caption-left {\n    text-align: left;\n}\n.carousel-caption {\n    text-shadow: none;\n    right: 0;\n    left: 0;\n    top: 60px;\n    bottom: 60px;\n    font-weight: 300;\n}\n.carousel-caption .container {\n    padding: 0 60px;\n}\n.carousel-caption .title {\n    font-size: 64px;\n    margin: 0;\n    font-weight: 600;\n}\n.carousel-caption .price {\n    font-size: 36px;\n    margin: 0;\n    font-weight: 600;\n}\n.carousel-caption .price small {\n    font-size: 24px;\n}\n.carousel-caption .price span {\n    background: rgba(0,0,0,0.5);\n    color: #fff;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n.carousel-caption .btn {\n    border: 2px solid #fff;\n    color: #fff;\n    padding-left: 30px;\n    padding-right: 30px;\n    margin-top: 30px;\n    border-radius: 6px;\n}\n.carousel-caption .btn:hover,\n.carousel-caption .btn:focus {\n    background: rgba(255,255,255,0.25);\n}\n.carousel-caption p {\n    margin-bottom: 0;\n    font-size: 26px;\n}\n.carousel-caption.text-inverse .btn {\n    border-color: #333;\n    color: #333;\n    font-weight: 600;\n}\n.carousel .product-img {\n    position: absolute;\n    top: 40px;\n    max-height: 370px;\n}\n.carousel .product-img.left {\n    left: 60px;\n}\n.carousel .product-img.right {\n    right: 60px;\n}\n.carousel .product-img.bottom {\n    bottom: 0;\n}\n.carousel .bg-cover-img {\n    max-width: 100%;\n    position: absolute;\n    min-height: 100%;\n}\n.slider .carousel,\n.carousel .carousel-inner,\n.carousel .carousel-inner .item {\n    min-height: 450px;\n}\n.carousel-indicators li {\n    border-width: 2px;\n}\n\n\n/* 9.2 Item Element Setting */\n\n.item {\n    background: #fff;\n}\n.item.item-thumbnail {\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    border: 1px solid #c5ced4;\n}\n.item.item-thumbnail a,\n.item.item-thumbnail a:hover,\n.item.item-thumbnail a:focus {\n    text-decoration: none;\n}\n.item.item-thumbnail .item-image {\n    height: 130px;\n    text-align: center;\n    padding: 15px;\n    line-height: 100px;\n    display: block;\n    position: relative;\n}\n.item.item-thumbnail .item-image .discount {\n    position: absolute;\n    bottom: 0;\n    right: 15px;\n    line-height: 20px;\n    padding: 2px 10px;\n    color: #fff;\n    background: #2d353c;\n    font-weight: 600;\n    font-size: 13px;\n}\n.item.item-thumbnail .item-image img {\n    max-width: 100%;\n    max-height: 100%;\n}\n.item.item-thumbnail .item-info {\n    padding: 15px;\n    text-align: center;\n}\n.item.item-thumbnail .item-title {\n    margin: 0 0 3px;\n}\n.item.item-thumbnail .item-title,\n.item.item-thumbnail .item-title a {\n    font-weight: 600;\n    color: #212121;\n    font-size: 14px;\n    line-height: 18px;\n    max-height: 36px;\n    overflow: hidden;\n}\n.item.item-thumbnail .item-title a:hover,\n.item.item-thumbnail .item-title a:focus {\n    color: #009688;\n}\n.item.item-thumbnail .item-desc {\n    margin: 0;\n    font-size: 12px;\n    color: #707478;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.item.item-thumbnail .item-discount-price {\n    font-size: 12px;\n    color: #999;\n    text-decoration: line-through;\n}\n.item.item-thumbnail .item-price {\n    margin: 3px 0;\n    font-size: 16px;\n    color: #009688;\n    font-weight: 600;\n}\n\n.caurosel-bg-cover-img {\n    position: relative !important;\n    width: 100%;\n}\n  \n.caurosel-image-container {\n    position: absolute !important;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
